const Loader = () => (
  <div className="absolute z-[60] top-0 left-0 right-0 h-[2px] w-full bg-slate-300/60 overflow-hidden">
    <div className="animate-loader w-full h-[2px] bg-slate-600"></div>
  </div>
);

export { Loader };
